// extracted by extract-css-chunks-webpack-plugin
module.exports = {"relateShortRecom":"relateShortRecom-2U0B2k-w"};